import React, { Component } from 'react'
import { CardDeck, Row, Col, Container, Card, Button, Modal } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.css';
import '../css/UpdateUserProfile.css';
import '../css/AddBulkTransaction.css';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import axiosConfig from '../config/axiosConfig'
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Toast } from 'primereact/toast';

import '../css/AdvanceDeleteButtonTable.css'
import { ExcelRenderer, OutTable } from 'react-excel-renderer';

const customStyles = {
    option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "black" : "black",
        backgroundColor: state.isSelected ? "#7367f0" : "white",
    }),
    control: (provided) => ({
        ...provided,
        borderRadius: "20px",
        borderColor: "#7367f0",
    }),
};
class AddBulkTransaction extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            SelectedType: '',
            TransactionDetaildata: [],
            TransactionDetailcolumns: [
                { "HeaderText": "OutletId", "MappingColomn": "outletId" },
                { "HeaderText": "ProductCode", "MappingColomn": "productCode" },
                { "HeaderText": "ActivityDateTime", "MappingColomn": "activityDateTime" },
                { "HeaderText": "PAN", "MappingColomn": "pan" },
                { "HeaderText": "Amount", "MappingColomn": "amount" },
                { "HeaderText": "Quantity", "MappingColomn": "quantity" },
                { "HeaderText": "OdometerReading", "MappingColomn": "odometerReading" },
                { "HeaderText": "Vrn", "MappingColomn": "vrn" },
                { "HeaderText": "Price", "MappingColomn": "price" }

            ],
            globalSearchBox: '',
            datakeyName: '',
            PageSize: 10,
            UserBranchID: localStorage.getItem("selectedBranch")
        }

        this.changeHandler = this.changeHandler.bind(this);
        this.TransactionsUpload = this.TransactionsUpload.bind(this)

    }

    componentWillMount() {

    }
    componentDidMount() {
        const data = {
            UserBranchID: this.props.data.selectedBranchId,
        };

    }

    fileData = event => {

        // Update the state
        this.setState({ selectedFile: event.target.files[0] });

    };

    // On show data (click the upload button)
    onShowData = () => {

            // Create an object of formData
            const formData = new FormData();

            // Update the formData object
            formData.append(
                "myFile",
                this.state.selectedFile,
                this.state.selectedFile.name
            );

            // console.log("Files Reading");
            // Details of the uploaded file
            // console.log(this.state.selectedFile);

            //just pass the fileObj as parameter
            ExcelRenderer(this.state.selectedFile, (err, resp) => {
                console.log(resp);
                if (err) {
                    console.log(err);
                }
                else {
                    this.setState({
                        cols: resp.cols,
                        rows: resp.rows
                    });
                    // console.log("row " + this.state.rows[0][0])
                    // console.log("counts " + this.state.cols.length)
                    // let columns = []
                    // for (var i = 0; i < this.state.cols.length; i++) {
                    //     let column = {
                    //         HeaderText: this.state.rows[0][i],
                    //         MappingColomn: this.state.ColumnsMapping[i]
                    //     }
                    //     columns.push(column);


                    // }
                    // this.setState({ TransactionDetailcolumns: columns });

                    let Rows = []
                    for (var i = 0; i < this.state.rows.length; i++) {
                        let row = {
                            outletId: this.state.rows[i][0],
                            productCode: this.state.rows[i][1],
                            activityDateTime: this.state.rows[i][2],
                            pan: this.state.rows[i][3],
                            amount: this.state.rows[i][4],
                            quantity: this.state.rows[i][5],
                            odometerReading: this.state.rows[i][6],
                            vrn: this.state.rows[i][7],
                            price: this.state.rows[i][8]

                        }

                        Rows.push(row);

                    }
                    this.setState({ TransactionDetaildata: Rows });
                    // console.log("TransactionDetailcolumn " + this.state.TransactionDetailcolumns[0].name)

                }
            });
        
    };


    changeHandler(p) {
        var newState = {};
        newState[p.target.name] = p.target.value;
        this.setState(newState);
    }


    TransactionsUpload = (e) => {
        const data = {
            transaction: this.state.TransactionDetaildata,
            UserBranchID: this.props.data.selectedBranchId,

        };
        axiosConfig.post("Portal/AddBulkTransactions", data)
            .then(Response => {
                Swal.fire({
                    icon: 'success',
                    title: Response.data.status.description,
                })
                    .then((result) => {
                        if (result.isConfirmed) {
                            localStorage.setItem('tabClosed', 'false');
                            window.location.reload();
                        }
                    })

            })
            .catch(error => {
                Swal.fire({
                    title: error.errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            })

    }

    render() {

        return (
            <>
                <Row className="p-3">
                    <Card className="p-3" style={{ width: "100%" }}>
                        <Card.Title>
                            <div className="pull-left">
                                Add Manual Transactions in Bulk
                                <br></br>
                            </div>
                        </Card.Title>

                        <Card.Body>
                            <div>

                                <div class="panel-body" style={{ margin: '30px auto' }}>
                                    <div class="input-group" style={{ justifyContent: 'center' }}>
                                        <div class="pull-middle" style={{ display: 'flex' }}>
                                            <div><input id="uploadFile" class="form-control" placeholder="Choose File" disabled="disabled" /></div>
                                            <div class="input-group-btn" style={{ margin: '0 24px' }}>
                                                <div class="fileUpload btn btn-success">
                                                    <span><i class="glyphicon glyphicon-upload"></i> Choose File</span>
                                                    <input id="uploadBtn" type="file" class="upload" onChange={this.fileData} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                            </div>
                            <div>
                                <div class="pull-middle">
                                    <div className="form-label-group">

                                        <Button
                                            className="btn-shell"
                                            variant="warning"
                                            onClick={this.onShowData}
                                        >
                                            Show Data
                                        </Button>
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-12 col-12">
                                <h6 className="pull-left">Manual Transactions From File</h6>
                                <>
                                    <Toast ref={(el) => this.toast = el} />
                                    <div className="text-right mb-2">

                                        <input type="text" className="pb-2 form-control col-sm-2 col-12 pull-right" id="user-name" name="globalSearchBox" placeholder="Search..." onChange={this.changeHandler} />
                                    </div>
                                    <br></br>
                                    <br></br>
                                    <DataTable dataKey={this.state.datakeyName} ref={this.dt} class="Table" value={this.state.TransactionDetaildata} paginator rows={this.state.PageSize} sortMode="multiple" globalFilter={this.state.globalSearchBox} >
                                        {
                                            this.state.TransactionDetailcolumns.map(
                                                (item, index) => (
                                                    <Column field={item.MappingColomn} header={item.HeaderText} sortable></Column>
                                                )
                                            )
                                        }
                                    </DataTable>
                                </>
                            </div>
                            <div></div>
                            <div></div>
                            <div>
                                <div class="pull-middle">
                                    <div className="form-label-group">
                                        <Button
                                            className="btn-shell"
                                            variant="warning"
                                            onClick={this.TransactionsUpload}
                                        >
                                            Upload
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </Row>
            </>

        );
    }
}

export default AddBulkTransaction;









